import { Box, Typography } from '@material-ui/core';
import React, { useState } from 'react';

function SimReplacement() {
    return <Box>SIM Replacement</Box>;
}
export default SimReplacement;
